var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.title!='')?_c('div',{staticClass:"sub-nav"},[_c('span',{staticClass:"sub-nav-icon"},[_c('i',{staticClass:"cubeic-back",on:{"click":_vm.goBack}})]),_vm._v(" "),_c('span',{staticClass:"sub-nav-title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e74327a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/SubNav.vue
// module id = null
// module chunks = 